import Vue from 'vue';

const apiUrl = `${process.env.VUE_APP_API_BASEURL}`;

export function getMyTopics(): Promise<any> {
  return Vue.axios.get(`${apiUrl}/v1/me/forum/topics`);
}

export function getLatestTopics(): Promise<any> {
  return Vue.axios.get(`${apiUrl}/v1/forum/topics/latest`);
}

export function getMyLatestTopics(): Promise<any> {
  return Vue.axios.get(`${apiUrl}/v1/me/forum/topics/latest`);
}

export function getMyCategoryTopics(categoryId: number): Promise<any> {
  return Vue.axios.get(`${apiUrl}/v1/me/forum/topics/category/${categoryId}`);
}

export function getLatestCategoryTopics(categoryId: number): Promise<any> {
  return Vue.axios.get(`${apiUrl}/v1/forum/topics/latest/${categoryId}`);
}

export function getCategoryTopics(categoryId: number): Promise<any> {
  return Vue.axios.get(`${apiUrl}/v1/Forum/Topics/Category/${categoryId}`);
}

export function getTopic(topicId: number): Promise<any> {
  return Vue.axios.get(`${apiUrl}/v1/forum/topics/${topicId}`);
}

export function createTopic(
  topicTitle: string,
  categoryId: number
): Promise<any> {
  const body = {
    topicTitle: topicTitle,
    categoryId: categoryId
  };
  return Vue.axios.post(`${apiUrl}/v1/forum/topics`, body);
}

export function editTopic(topicId: number, topicTitle: string): Promise<any> {
  return Vue.axios.put(`${apiUrl}/v1/Forum/Topics/${topicId}`, { topicTitle });
}
